<template>
  <div class="add_edit">
    <van-form @submit="onSave" ref="refForm">
      <van-field v-model="dataForm.deliveryPerson" clearable label="姓名" name="姓名" placeholder="收货人姓名" :rules="[{ validator: checkName, message: '' }]" />
      <van-field v-model="dataForm.telNo" clearable type="tel" label="电话" name="电话" placeholder="收货人电话" :rules="[{ validator: checkPhone, message: '' }]" />
      <van-cell title="地区" is-link :value="cascaderText || '请选择所在地区'" @click="showPopArea = true" />
      <van-field v-model="dataForm.detailAddr" autosize rows="1" type="textarea" label="详细地址" name="详细地址" placeholder="详细地址" :rules="[{ required: true, message: '请填写详细地址' }]" />
      <van-cell center title="设为默认收货地址">
        <template #right-icon>
          <van-switch v-model="dataForm.isDefault" size="24" />
        </template>
      </van-cell>
      <div style="padding: 32px 0;">
        <van-button round block type="danger" native-type="submit">保存</van-button>
        <van-button v-if="this.dataForm.id" round block native-type="button" @click="onDelete">删除</van-button>
      </div>
    </van-form>

    <van-popup v-model="showPopArea" round position="bottom">
      <van-cascader v-model="dataForm.townId" title="请选择所在地区" :options="options" @close="showPopArea = false" @change="onSelectItem" @finish="onFinish" />
    </van-popup>
  </div>
</template>

<script>
import {
  GetProList,
  GetDisList,
  GetTownList,
  AddAddress,
  UpdateAddress,
  DelAddress,
} from "@/pages/page1/api-work/index";
import { validMobile, validatetypeName } from "@/pages/publicUtils/validate";
import {
  Form,
  Field,
  Cascader,
  popup,
  Button,
  Toast,
  Cell,
  Switch,
  Dialog,
} from "vant";
export default {
  metaInfo: { title: "我的地址" },
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [popup.name]: popup,
    [Cascader.name]: Cascader,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      showPopArea: false,
      options: [],
      dataForm: {
        id: "",
        deliveryPerson: "", //姓名
        telNo: "", //手机
        detailAddr: "", //详细地址
        isDefault: 0, //默认地址？
        provinceCode: "",
        cityCode: "",
        disCode: "",
        townId: "",
        provinceName: "",
        cityName: "",
        disName: "",
        townName: "",
      },
    };
  },
  methods: {
    onSave() {
      if (!this.cascaderText) {
        Toast("请选择地区");
        return;
      }
      this.dataForm.isDefault = this.dataForm.isDefault ? 1 : 0;
      if (this.dataForm.id) {
        UpdateAddress(this.dataForm).then((res) => {
          // console.log("修改地址", res);
          this.$emit("actionComplete");
        });
      } else {
        AddAddress(this.dataForm).then((res) => {
          // console.log("新增地址接口", res);
          this.$emit("actionComplete");
        });
      }
    },
    onDelete() {
      let _that = this;
      Dialog.confirm({
        message: "确认删除吗？",
        beforeClose: (action, done) => {
          if (action === "confirm") {
            DelAddress({ id: _that.dataForm.id })
              .then((res) => {
                // console.log("删除接口", res);
                if (this.$store.state.work.addressID === _that.dataForm.id) {
                  this.$store.commit("SET_ADDRID", undefined);
                }
                this.$emit("actionComplete");
                done();
              })
              .catch(() => {
                done();
              });
          } else {
            done();
          }
        },
      }).catch(() => {});
    },
    clearForm() {
      this.$refs.refForm.resetValidation(); //重置验证提示
      for (const key in this.dataForm) {
        this.dataForm[key] = "";
      }
      this.dataForm.isDefault = false;
      this.getProAndCityList();
    },
    setForm(item) {
      // console.log(item);
      this.$refs.refForm.resetValidation(); //重置验证提示
      this.dataForm = item;
      this.getProAndCityList();
    },
    // 地区处理
    onSelectItem({ value, selectedOptions, tabIndex }) {
      // 选中城市 获取区县
      if (tabIndex == 1) {
        this.getDisList(value, false);
      }
      // 选中区县 获取街道
      if (tabIndex == 2) {
        this.getTownList(value);
      }
    },
    // 没有 children 时触发
    onFinish({ selectedOptions }) {
      selectedOptions.forEach((v, i) => {
        switch (i) {
          case 0:
            this.dataForm.provinceCode = v.value;
            this.dataForm.provinceName = v.text;
            break;
          case 1:
            this.dataForm.cityCode = v.value;
            this.dataForm.cityName = v.text;
            break;
          case 2:
            this.dataForm.disCode = v.value;
            this.dataForm.disName = v.text;
            break;
          case 3:
            this.dataForm.townId = v.value;
            this.dataForm.townName = v.text;
            break;
        }
      });
      this.showPopArea = false;
    },
    // 省市
    getProAndCityList() {
      GetProList({}).then((res) => {
        // console.log("获取省市数据", res);
        this.options = this.repliceKey(res.data);
        // console.log("数据一二层", this.options);

        // 初始化 省市区街道dom不存在 不能选中的问题
        if (this.dataForm.id) {
          this.getDisList(this.dataForm.cityCode, true);
        }
      });
    },
    // 区县
    getDisList(code, noAction) {
      GetDisList({ cityCode: code }).then((res) => {
        // console.log("获取区县数据", res);
        this.options.forEach((item) => {
          item.children.forEach((v) => {
            if (v.value === code) {
              v.children = this.repliceKey(res.data);
            }
          });
        });
        // console.log("数据第三层", this.options);
        if (this.dataForm.id && noAction) {
          this.getTownList(this.dataForm.disCode);
        }
      });
    },
    // 街道
    getTownList(code) {
      GetTownList({ districtCode: code }).then((res) => {
        // console.log("获取街道数据", res);
        this.options.forEach((item) => {
          item.children.forEach((v) => {
            v.children.forEach((j) => {
              if (j.value === code) {
                j.children = this.repliceTownKey(res.data);
              }
            });
          });
        });
        // console.log("数据第四层", this.options);
      });
    },
    // 数据处理 code=>value name=>text 下一层children准备
    repliceKey(arr) {
      arr.forEach((item) => {
        item.value = item.code;
        item.text = item.name;
        item.children = item.children || [];
        delete item.code;
        delete item.name;
        if (item.children.length > 0) {
          this.repliceKey(item.children);
        }
      });
      return arr;
    },
    // 街道数据处理
    repliceTownKey(arr) {
      arr.forEach((item) => {
        item.value = item.id;
        item.text = item.name;
      });
      return arr;
    },
    // 验证
    checkPhone(val) {
      if (!val) {
        Toast("请填写收货人电话");
        return false;
      }
      if (!validMobile(val)) {
        Toast("手机号格式不对");
        return false;
      }
      return true;
    },
    checkName(val) {
      if (!val) {
        Toast("请填写收货人姓名");
        return false;
      }
      if (val.length < 2 || val.length > 12) {
        Toast("最少2个最多12个字符");
        return false;
      }
      if (!validatetypeName(val)) {
        Toast("请填写中文或英文姓名");
        return false;
      }
      return true;
    },
  },
  computed: {
    cascaderText() {
      let val = "";
      if (!this.dataForm.townName) return val;
      val += this.dataForm.provinceName + "/";
      val += this.dataForm.cityName + "/";
      val += this.dataForm.disName + "/";
      val += this.dataForm.townName;
      return val;
    },
  },
};
</script>

<style lang="less" scoped>
.add_edit {
  padding: 0.24rem;
  box-sizing: border-box;
  .van-form {
    border-radius: 8px;
    overflow: hidden;
    .van-cell--clickable {
      .van-cell__title {
        flex: none;
      }
      .van-cell__value {
        padding-left: 12px;
        box-sizing: border-box;
      }
    }
    .van-button {
      &:nth-child(2) {
        margin-top: 12px;
      }
    }
  }
}
</style>